// APSDataService: wraps backend APS endpoints
import API from 'app/api';

class APSDataService {
    // Hubs
    async getHubs() {
        const { data } = await API.get('/aps/hubs');
        return data;
    }

    // Projects in a hub
    async getProjects(hubId) {
        if (!hubId) throw new Error('hubId is required');
        const { data } = await API.get(`/aps/hubs/${encodeURIComponent(hubId)}/projects`);
        return data;
    }

    // Project root folder (top container) in a hub
    async getProjectRootFolder(hubId, projectId) {
        if (!hubId) throw new Error('hubId is required');
        if (!projectId) throw new Error('projectId is required');
        const { data } = await API.get(`/aps/hubs/${encodeURIComponent(hubId)}/projects/${encodeURIComponent(projectId)}/topFolders`);
        return data;
    }

    // Folder contents within a project
    async getFolderContents(projectId, folderId) {
        if (!projectId) throw new Error('projectId is required');
        if (!folderId) throw new Error('folderId is required');
        const { data } = await API.get(`/aps/projects/${encodeURIComponent(projectId)}/folders/${encodeURIComponent(folderId)}/contents`);
        return data;
    }

    // All versions for an item
    async getItemVersions(projectId, itemId) {
        if (!projectId) throw new Error('projectId is required');
        if (!itemId) throw new Error('itemId is required');
        const { data } = await API.get(`/aps/projects/${encodeURIComponent(projectId)}/items/${encodeURIComponent(itemId)}/versions`);
        return data;
    }

    // Latest (tip) version for an item
    async getLatestItemVersion(projectId, itemId) {
        if (!projectId) throw new Error('projectId is required');
        if (!itemId) throw new Error('itemId is required');
        const { data } = await API.get(`/aps/projects/${encodeURIComponent(projectId)}/items/${encodeURIComponent(itemId)}/tip`);
        return data;
    }

    // Model manifest / viewable check
    async checkViewable(urn) {
        if (!urn) throw new Error('urn is required');
        const encodedUrn = encodeURIComponent(urn);
        const { data } = await API.get(`/aps/modelderivative/${encodedUrn}/manifest`);
        return data;
    }

    // Prepare a model for viewing (derivative job)
    async prepareModel(urn) {
        if (!urn) throw new Error('urn is required');
        const { data } = await API.post('/aps/modelderivative/jobs', { urn });
        return data;
    }
}

const apsDataService = new APSDataService();
export default apsDataService;
